<template>
  <div class="flex flex-wrap items-center gap-2 mb-4">
    <div class="flex-1" :class="$style.header">
      <div class="material-icons-outlined">
        {{ icon }}
      </div>
      <h2>
        {{ title }}
        <span v-if="subHeader" class="text-subtle font-medium">
          {{ subHeader }}
        </span>
      </h2>
      <slot name="header" />
    </div>
    <slot name="button" />
    <CButton
      v-if="buttonClick && !$slots.button"
      :icon="buttonIcon"
      :class="buttonClass"
      size="sml"
      color="white"
      @click="buttonClick"
    />
  </div>
</template>

<script setup lang="ts">
type Props = {
  title: string;
  icon: string;
  buttonIcon?: string;
  buttonClass?: string;
  buttonClick?: () => void;
  subHeader?: string;
};
defineProps<Props>();
</script>

<style module>
.header {
  user-select: none;
  display: flex;
  gap: 0.25rem;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  min-width: fit-content;
}
</style>
